import React from "react";

export const Image = ({ title, description, largeImage, smallImage }) => {
  return (
    <div className="servicios-item">
      <div className="hover-bg">
        {" "}
        <a title={title} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4 className="hover-text-upp">{title}</h4>
            <p>{description}</p>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
